module.exports = __webpack_public_path__ + "static/visitorimage-199c8e7f522cca7b4a470708ffd8f7ec.png";